module.exports = __webpack_public_path__ + "halipar.jpg?0dac7a2df6015f55f65a41971e8720f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/halipar.jpg
// module id = 120
// module chunks = 0